import { Stack, Typography } from '@mui/material';
import React from 'react';

export function DataMaidProcessDocumentPage() {
  return (
    <Stack
      border="1px dashed"
      borderColor="primary.main"
      borderRadius={3}
      p={2}
      height="300px"
      width="100%"
      justifyContent="center"
      alignItems="center"
    >
      <Typography>
        Drop csv, xml, txt, png, jpg, pdf, etc. files here
      </Typography>
    </Stack>
  );
}
